var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("\n    Klicka här så bygger du ett dubbelställ, alltså 2 enkelställ som monteras ihop med 150 mm distanser. Du får dubbelt så många pallplatser, dubbelstället kan lastas från 2 håll.\n  ")])])
}]

export { render, staticRenderFns }